import { Directive, OnDestroy, OnInit, Optional, Self } from "@angular/core";
import { NgControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { AutoSaveDirective } from "./auto-save.directive";

@Directive({
    selector: "[autoSaveIgnore]"
})
export class AutoSaveIgnoreDirective implements OnInit, OnDestroy {
    private changesSubscription: Subscription;

    constructor(@Optional() private autoSaveDirective: AutoSaveDirective, @Self() private ngControl: NgControl) {}

    ngOnInit(): void {
        if (!this.autoSaveDirective) {
            return;
        }

        this.changesSubscription = this.ngControl.valueChanges.subscribe(_ => {
            if (this.ngControl.touched || this.ngControl.dirty) {
                this.autoSaveDirective.ignoredFieldModified();
            }
        });
    }

    ngOnDestroy(): void {
        this.changesSubscription?.unsubscribe();
    }
}
